import { ChevronLeftIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import { Hash } from "../../../api/@types/apiTypes";
import StudentModel from "../../../api/models/StudentModel";
import UserProfilePictureAvatar from "../../../components/avatar/UserProfilePictureAvatar";
import { useNavigate } from "react-router-dom";

type ReadersTableProps = {
  readers: StudentModel[];
  telawahs: Hash<string>;
};
export const ReadersTable = (props: ReadersTableProps) => {
  const { readers, telawahs } = props;
  const LocalBasePath = "page.tutor.dashboard.readers";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const navigate = useNavigate();
  return (
    <div className="">
      <table className="min-w-full divide-y table-fixed divide-gray-300">
        <thead className="bg-gray-50">
          <tr className="">
            <th
              scope="col"
              className=" px-3  py-3.5 text-justify text-sm font-semibold text-gray-500"
            >
              {t("readerName")}
            </th>
            <th
              scope="col"
              className="py-3.5 ps-4 pe-3  text-justify text-sm font-semibold text-gray-500 sm:ps-6 hidden md:table-cell"
            >
              {t("recitation")}
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-justify text-sm font-semibold text-gray-500 hidden md:table-cell"
            >
              {t("pagesFinishing")}
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-justify text-sm font-semibold text-gray-500 hidden md:table-cell"
            >
              {t("sessions")}
            </th>
            <th scope="col" className="py-3.5 ps-3 pe-4 sm:pe-6">
              <span className="sr-only">More options</span>
            </th>
          </tr>
        </thead>
        <tbody data-cy="studentsTable">
          <>
            {readers.map((reader, index) => {
              return (
                <tr
                  key={`StudentInfoTable_${index}_${reader.id}`}
                  className={" border-t cursor-pointer hover:bg-gray-50"}
                  onClick={() => {
                    navigate(`/tutor/dashboard/student/${reader.id}`);
                  }}
                >
                  <td className="px-3 py-3.5">
                    <div className="flex gap-3 pe-4">
                      <UserProfilePictureAvatar
                        profilePictureUrl={reader?.profile_picture_url}
                        className="w-10 h-10"
                        alt="sand-user-img"
                      />
                      <div className="flex items-start gap-1 flex-col">
                        <h3 className="text-sm font-medium text-gray-800">
                          {reader?.full_name ??
                            `${reader?.firstName} ${reader?.lastName}`}
                        </h3>
                        <p className="text-xs font-normal text-gray-400">
                          {reader.sponsorship?.sponsor?.name && (
                            <span className="flex justify-start gap-1">
                              <span>{reader.sponsorship.sponsor.name}</span>
                              <span>{t("backSlash")}</span>
                              <span>{reader.sponsorship.id}</span>
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="relative py-4 ps-4 sm:ps-6 pe-3 text-sm hidden md:table-cell">
                    <div className="font-medium text-gray-500">
                      {telawahs[reader.telawah_id!]}
                    </div>
                  </td>
                  <td className="px-3 py-3.5 text-sm text-gray-500 hidden md:table-cell ">
                    {reader.lastQuranPageReached} / 604
                  </td>
                  <td className="px-3 py-3.5 text-sm text-gray-500 hidden md:table-cell ">
                    {`${reader.finished_sessions_count} / ${reader.total_sessions_count}`}
                  </td>
                  <td className=" px-3 py-3.5 text-sm text-gray-500">
                    <div className="flex justify-end">
                      <ChevronLeftIcon
                        className="h-4 w-4 text-gray-900 ltr:rotate-180"
                        aria-hidden="true"
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </>
        </tbody>
      </table>
    </div>
  );
};
